import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { MessageService } from 'primeng/api';
import { QueryViewModel } from '../../models/query-view-model';
import { ConstantsService } from '../../services/constants.service';
import { QueryStateService } from '../../services/query-state.service';

@Component({
  selector: 'app-results-search-info',
  templateUrl: './results-search-info.component.html',
  styleUrls: ['./results-search-info.component.css']
})
export class ResultsSearchInfoComponent implements OnInit {

  @Input() queryString?: string | null;
  @Input() routeLink: string = '';

  query: QueryViewModel = {};
  saveSearchVisible: boolean = false;
  showCopyMsg: boolean = false;

  constructor(private queryStateSvc: QueryStateService,
    public constants: ConstantsService,
    private router: Router,
    private clipboardApi: ClipboardService,
    private msgService: MessageService
  ) { }

  ngOnInit(): void {
    // this.query = this.queryStateSvc.getQueryView();
    this.queryStateSvc.qData$.subscribe(data => {
      this.query = data;
    });
  }

  saveSearch() {
    this.saveSearchVisible = true;
    // let qd = encodeURIComponent(JSON.stringify(this.querySvc.getFormData()));
    // this.savedSearchItem = { query: qd, formData: qd, id: '', displayName: '' };
    // this.saveSearchName = '';
  }
  
  closeSaveSearch() {
    this.saveSearchVisible = false;
  }

  submitForm() {
    this.queryStateSvc.clearSelectedFacets();
    this.queryStateSvc.updateSkipCount(0);
    
    this.router.navigate(["adv-search"]);
  }

  copyClipboard() {
    // console.log('query: ' + JSON.stringify(this.queryString));

    if (this.queryString) {
      this.clipboardApi.copyFromContent(this.routeLink);
      this.showCopyMsg = true;
      this.msgService.add({ severity: 'success', summary: 'Search Copied', detail: 'Search Query Copied to Clipboard!' });
    }
  }
}
